import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

import * as styles from "../styles/Home.js";
import * as title from "../constants/titles_home.js";
import Card from "./Card.js";
import ObjetivoBox from "./Home_objetivo.js";
import InvertirBox from "./Home_invertir.js";
import AccionesBox from "./Home_acciones.js";
import CedearsBox from "./Home_cedears.js";
import CedearsMobile from "./Home_cedears_mobile.js";

export default function Home() {
  const handleOpenCedears = () => {
    window.location.href = "/Cedears"; // Abre la URL en una nueva pestaña cuando se toca cualquiera de los ratios
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    // INVERSIMPLE

    <Box style={styles.backgroundStyle}>
      <Box sx={styles.containerStyle}>
        <Typography sx={styles.styleInversimple}>
          <span style={{ fontWeight: "bold" }}>INVER</span>
          <span style={{ fontWeight: "lighter" }}>SIMPLE</span>
        </Typography>
        <Typography variant="h6" sx={styles.styleInverTexto}>
          {title.InverSimpleTexto}
        </Typography>
        <Box sx={styles.styleInverBox}>
          {title.InverSimpleBox.map((data, index) => (
            <Card
              key={index}
              title={data.title}
              text={data.text}
              icon={data.image}
              color={
                index === 2
                  ? "#355CAE"
                  : "#FFFFFF"
              }
            />
          ))}
        </Box>
      </Box>
      {/* Porque inversimple, porque invertir, porque acciones */}
      <ObjetivoBox></ObjetivoBox>
      <InvertirBox></InvertirBox>
      <AccionesBox></AccionesBox>
      {/* Que son los cedears, ventajas de los cedears */}
      {isMobile ? (
        <CedearsMobile handleClick={handleOpenCedears} />
      ) : (
        <CedearsBox handleClick={handleOpenCedears} />
      )}
    </Box>
  );
}

//Hay que ajustarlo con media queries, fijarse en el nav

// Como evaluar una inversion
//         <Box sx={backgroundStyle2}></Box>
//           <Box sx={{marginBottom:"30px"}}>
//             <Typography align="center" variant="h2" color={"#2a4886"} sx={{marginTop:"20px", marginBottom:"30px"}}>¿Cómo evaluar una inversión?</Typography>
//             <Box sx={{display:"flex"}}>
//               <Typography align="justify" sx={{marginLeft:"70px", marginRight:"30px", fontSize:"18px"}}>
//                 Una inversión en acciones se evalúa como cualquier inversión ya sea compra de un inmueble, oro o dólar billete. Todo se reduce a riesgo/beneficio.
//                 Por ejemplo, la compra de dólar billete para atesorar es una inversión sin ningún tipo de riesgo, pero cuyo beneficio es 0. El único objetivo es mantener el poder adquisitivo del dinero (contra el peso argentino). No hay que dejar de tener en cuenta que en Estados Unidos existe inflación también, un dólar guardado debajo de un colchón hace 20 años hoy perdió un 40% de poder adquisitivo.
//                 Si continuamos analizando las inversiones, la compra de oro físico siempre se caracterizó como opción para no perder poder adquisitivo contra el dólar.En este caso el riesgo es un poco más elevado (al ser un commodity su precio puede variar) pero el beneficio es mayor a 0, históricamente el oro sirvió como refugio contra la inflación del dólar.
//               </Typography>
//               <Typography align="justify" sx={{marginLeft:"30px", marginRight:"30px", fontSize:"18px"}}>
//                 Para poner un caso conocido, la compra de inmuebles siempre fue una opción llamativa para los inversores en Argentina. En este caso, el riesgo es bajo pero lo que muchos no entienden es que el beneficio es extremadamente bajo. Hoy un departamento que cuesta 100.000 dólares arroja un alquiler aproximado de 200 dólares mensuales. A 1200 dólares por año se tardarían 83 años de alquiler para recuperar la inversión inicial, sin tener en cuenta los gastos de mantenimiento y administración del mismo.
//                 En el mundo de las acciones, los retornos de inversión suelen estar por debajo de 30 años, pero esto puede variar, incluso hay empresas que todavía no ganan dinero por lo cual es imposible calcular un retorno de inversión. El indicador utilizado para calcular el retorno de la inversión en años es el PER (price to earnings) y básicamente nos dice cuantos años deberían pasar para recuperar nuestra inversión inicial.
//               </Typography>
//               <Typography align="justify" sx={{marginLeft:"30px", marginRight:"70px", fontSize:"18px"}}>
//                 Algo parecido sucede con los bonos, en este caso, el riesgo suele ser más bajo que las acciones pero con un menor beneficio esperado. Hoy en día el bono más seguro del mundo (bono del tesoro de Estados Unidos) está ofreciendo un 5% anual en dólares, arrojando un retorno de inversión de 20 años. Es una locura pensar que el activo más seguro del mundo rinde casi 4 veces más que un departamento, donde existen riesgos de desvalorización, mantenimiento de la propiedad, problemas con el inquilino, etc.
//                 Desde argentina se puede invertir en bonos soberanos (con altísimo riesgo pero también un retorno alto) y bonos corporativos, deuda que emiten las empresas más importantes del pais (YPF, Banco Galicia, Telecom, etc) y que ofrecen un rendimiento moderado con un riesgo inferior al de los bonos soberanos.
//               </Typography>
//             </Box>
//           </Box>
